import type { FunctionComponent } from 'react';
import {
  Parameter,
  CheckoutPageParameter,
  InputClassParameter,
  ThemeParameters,
  LandingPageParameter,
  ProductAdderParameters,
  AccountPageParameter,
  DirectLinkParameters,
} from './parameters';
import CartPreview from '../components/Cart/CartPreviewButton';
import Checkout from '../components/Checkout/Checkout';
import ProductAdder from '../components/Product/ProductAdder';
import Account from '@src/components/Account';
import OpenPurchaseNotification from '@src/components/OpenPurchaseNotification';
import DirectLinkWidget from '@src/widgets/DirectLink';
import PartnershipBanner from '@src/widgets/PartnershipBanner';

export interface Widget {
  name: string;
  component: FunctionComponent;
  parameters: Parameter[];
}

export default [
  {
    name: 'cart-preview',
    component: CartPreview,
    parameters: [...ThemeParameters, CheckoutPageParameter, LandingPageParameter],
  },
  { name: 'product-adder', component: ProductAdder, parameters: [...ProductAdderParameters] },
  {
    name: 'checkout',
    component: Checkout,
    parameters: [
      { name: 'continue-shopping-page', optional: true },
      { name: 'continue-shopping-text', optional: true },
      { name: 'proceed-sale-text', optional: true },
      { name: 'on-checkout-init', optional: true },
      { name: 'on-sale-completion', optional: true },
      { name: 'skip-resume-cart-page', optional: true },
      { name: 'checkout-redirect-to', optional: true },
      { name: 'checkout-redirect-button-text', optional: true },
      { name: 'logout-redirect-to', optional: true },
      InputClassParameter,
    ],
  },
  { name: 'account', component: Account, parameters: [InputClassParameter] },
  {
    name: 'open-purchase-notification',
    component: OpenPurchaseNotification,
    parameters: [InputClassParameter, AccountPageParameter, CheckoutPageParameter],
  },
  {
    name: 'direct-link',
    component: DirectLinkWidget,
    parameters: DirectLinkParameters,
  },
  {
    name: 'partnership-banner',
    component: PartnershipBanner,
    parameters: [],
  },
] as Widget[];
